import { useRef } from "react";
import { Select } from "antd";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { search_skill_user_action } from "../../redux/_actions";

export const AssessmentSkillInput = ({
  searchStyle,
  placeholder,
  onSearchSelect,
  clearSearch,
  defaultSkillValue,
  dropdownStyle,
  isSkillIdNeed,
  data,
}) => {
  const [skillData, setSkillData] = useState([]);
  const [value, setValue] = useState(defaultSkillValue);
  const [loading, setLoading] = useState();
  const [searchValue, setSearchValue] = useState(null);

  const { skillSearchData } = useSelector(
    (state) => state.search_skill_user_reducer
  );
  const ref = useRef();
  useEffect(() => {
    if (ref?.current && ref?.current?.value) {
      ref.current.value = defaultSkillValue;
    }
  }, []);
  const dispatch = useDispatch();

  useEffect(() => {
    setSkillData(data);
  }, []);

  useEffect(() => {
    setSkillData(data);
  }, [data]);

  const handleSearch = async (newValue) => {
    setSearchValue(newValue);
  };

  const handleChange = (newValue) => {
    if (newValue) onSearchSelect(newValue);
    if (clearSearch) {
      setSearchValue(null);
      setValue(null);
    }
  };
  return (
    <>
      <Select
        ref={ref}
        showSearch
        value={value}
        className="col-lg-12 px-0 position-relative h-auto"
        searchValue={searchValue}
        placeholder={placeholder}
        style={searchStyle}
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        onSearch={handleSearch}
        onChange={handleChange}
        allowClear={true}
        dropdownStyle={dropdownStyle}
        notFoundContent={
          loading ? (
            <Spinner animation="grow" variant="primary" size={"sm"} />
          ) : searchValue && searchValue.length > 0 ? (
            !clearSearch ? (
              <p>No skills found</p>
            ) : (
              <p
                onClick={() => handleChange(searchValue)}
                className="text-primary"
              >
                Add "{searchValue}"
              </p>
            )
          ) : null
        }
        options={
          Array.isArray(skillData) &&
          skillData.map((d) => ({
            value: isSkillIdNeed ? `${d?.id},${d?.skill}` : d?.skill,
            label:
              d?.skill &&
              `${d.skill.charAt(0).toUpperCase() + d.skill.slice(1)}`,
          }))
        }
        getPopupContainer={(trigger) => trigger.parentNode}
      />
    </>
  );
};
